import React from 'react';
import PropTypes from 'prop-types';
import SwitchButton from '../../../../Form/ToggleSwitch/SwitchButton';

const ToggleSwitch = ({ id, isOn, onToggle, disabled = false }) => {
    const handleChange = (e) => {
        if (onToggle && !disabled) {
            onToggle(e.target.checked);
        }
    };

    const switchId = `toggle-${id}`;

    return (
        <div style={{ display: 'inline-block' }}>
            <SwitchButton
                checked={isOn}
                onChange={handleChange}
                disabled={disabled}
                theme="switch-button-flat-round"
                mode="switch"
                id={switchId}
                name={switchId}
            />
        </div>
    );
};

ToggleSwitch.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isOn: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

ToggleSwitch.defaultProps = {
    isOn: false,
    disabled: false,
};

export default ToggleSwitch;
